@if (enableFilter()) {
    <button
        type="button"
        class="btn btn-sm bg-card rounded-circle shadow-sm"
        [class.text-primary]="!isFilterApplied()"
        [class.text-info]="isFilterApplied()"
        [title]="'tooltips.filter' | translate"
        id="listButtonFilter"
        (click)="filterClicked.emit(true)"
    >
        <fa-icon [icon]="['fas', 'filter']"></fa-icon>
    </button>
}
@if (enableSettings()) {
    <button
        type="button"
        class="btn btn-sm bg-card text-primary rounded-circle shadow-sm"
        [title]="'tooltips.settings' | translate"
        id="listButtonSettings"
        (click)="settingsClicked.emit(true)"
    >
        <fa-icon [icon]="['fas', 'gear']"></fa-icon>
    </button>
}
@if (enablePrint()) {
    <button
        type="button"
        class="btn btn-sm bg-card text-primary rounded-circle shadow-sm"
        [title]="'tooltips.print' | translate"
        id="listButtonPrint"
        (click)="printClicked.emit(true)"
    >
        <fa-icon [icon]="['fas', 'print']"></fa-icon>
    </button>
}
@if (enableExport()) {
    <button
        type="button"
        class="btn btn-sm bg-card text-primary rounded-circle shadow-sm"
        [title]="'tooltips.export' | translate"
        id="listButtonExport"
        (click)="exportClicked.emit(true)"
    >
        <fa-icon [icon]="['fas', 'file-export']"></fa-icon>
    </button>
}
@for (item of customTableButtons(); track item) {
    <button
        type="button"
        class="btn btn-sm bg-card text-primary rounded-circle shadow-sm"
        [title]="item.iconTitle | translate"
        [id]="'listButton' + item.iconTitle"
        (click)="buttonClicked.emit(item.eventName)"
    >
        <i [class]="item.iconName"></i>
    </button>
}
@if (enableAdd()) {
    <button
        type="button"
        class="btn btn-sm bg-card text-primary rounded-circle shadow-sm"
        [title]="'tooltips.add' | translate"
        *adaaHasPermission="createPermission()"
        id="listButtonAdd"
        (click)="addNewClicked.emit()"
    >
        <fa-icon [icon]="['fas', 'plus']"></fa-icon>
    </button>
}
